import { render, staticRenderFns } from "./EntStats.vue?vue&type=template&id=2ffe51ca&scoped=true&"
import script from "./EntStats.vue?vue&type=script&lang=js&"
export * from "./EntStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ffe51ca",
  null
  
)

export default component.exports